import { NgModule } from '@angular/core';
import { FeinPipe } from './fein.pipe';
import { YesNoPipe } from './yes-no.pipe';
import { UTCMomentPipe } from './utc-moment.pipe';
import { EasternMomemtPipe } from './local-moment.pipe';
import { StringPadPipe } from './string-pad.pipe';
import { SsnMaskPipe } from './ssn-mask.pipe';
import { DateFormatPipe } from './date-format.pipe';
import { DateTimeFormatPipe } from './date-time-format.pipe';
import { PrefixPipe } from './prefix.pipe';
import { EntityFormatterPipe } from './entity-formatter.pipe';
import { ApprovedNameCharactersDirective } from 'projects/bis-shared/src/lib/utility/approved-name-characters.directive';
import { WordifyPipe } from './wordify.pipe';
import { FeinDisplayMaskPipe } from './fein-display-mask.pipe';
import { RandomService } from './random.service';
import { NgIdleModule } from '@ng-idle/core';
import { ZipCodeFormatterPipe } from './zip-code-formatter.pipe';
import { UiNumberPipe } from './ui-number.pipe';
import { EntityIdFormatterService } from './entity-id-formatter.service';
import { GetFromReferenceDataById } from './get-from-reference-data-by-id.pipe';
import { SelectOptionReverse } from './select-option-reverse.pipe';
import { IdleService } from './idle.service';
import { GetFromSourceById } from './get-from-source-by-id.pipe';
import { GetCodeFromReferenceDataById } from './get-code-from-reference-data-by-id.pipe';
import { CtrlKeysDirective } from './control-keys.directive';
import { ArraySortPipe } from './array-sort.pipe';
import { ApprovedNameCharactersForCaseSearchDirective } from './approved-name-characters-for-case-search.directive';
import { UsPhoneNumberPipe } from './us-phone-number.pipe';

@NgModule({
  imports: [
    NgIdleModule.forRoot(),
    FeinPipe,
    FeinDisplayMaskPipe,
    YesNoPipe,
    WordifyPipe,
    UTCMomentPipe,
    EasternMomemtPipe,
    StringPadPipe,
    SsnMaskPipe,
    DateFormatPipe,
    DateTimeFormatPipe,
    PrefixPipe,
    EntityFormatterPipe,
    ApprovedNameCharactersDirective,
    ApprovedNameCharactersForCaseSearchDirective,
    CtrlKeysDirective,
    ZipCodeFormatterPipe,
    UsPhoneNumberPipe,
    UiNumberPipe,
    GetFromReferenceDataById,
    GetCodeFromReferenceDataById,
    GetFromSourceById,
    SelectOptionReverse,
    ArraySortPipe,
    EntityFormatterPipe,
  ],
  exports: [
    FeinPipe,
    FeinDisplayMaskPipe,
    YesNoPipe,
    WordifyPipe,
    UTCMomentPipe,
    EasternMomemtPipe,
    StringPadPipe,
    SsnMaskPipe,
    DateFormatPipe,
    DateTimeFormatPipe,
    PrefixPipe,
    EntityFormatterPipe,
    ApprovedNameCharactersDirective,
    ApprovedNameCharactersForCaseSearchDirective,
    CtrlKeysDirective,
    ZipCodeFormatterPipe,
    UsPhoneNumberPipe,
    UiNumberPipe,
    GetFromReferenceDataById,
    GetCodeFromReferenceDataById,
    GetFromSourceById,
    SelectOptionReverse,
    ArraySortPipe,
    EntityFormatterPipe,
  ],
  declarations: [],
  providers: [
    RandomService,
    EntityIdFormatterService,
    IdleService,
    ZipCodeFormatterPipe,
  ],
})
export class UtilityModule {}
